import { Injectable } from '@angular/core';
import { AuthService } from '../common/auth/auth.service';

@Injectable()
export class LocationStore {
  constructor(private readonly auth: AuthService) {}

  private key() {
    return `location:${this.auth.getUserId()}`;
  }

  get(): string | null {
    return localStorage.getItem(this.key());
  }

  set(location: string): void {
    localStorage.setItem(this.key(), location);
  }
}
